import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import { Logo } from "./Navbar";

export default function Footer() {
  return (
    <footer className="relative border-t border-border bg-muted/40">
      <div className="mx-auto max-w-[1400px] px-6 py-20 lg:px-10">
        <div className="grid gap-14 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo />
            <p className="mt-6 max-w-sm leading-relaxed text-muted-foreground">
              A professional drug formulation company solving serious problems across drug
              development and delivery — from formulation science to gamma scintigraphy clinical
              trials.
            </p>
            <Link
              to="/contact"
              className="group mt-8 inline-flex items-center gap-2 font-serif-display text-2xl font-medium text-foreground transition-colors duration-300 hover:text-primary"
              data-testid="footer-cta"
            >
              Let&apos;s redefine your brand
              <ArrowUpRight className="h-6 w-6 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
            </Link>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-gold">Navigate</p>
            <ul className="mt-5 space-y-3">
              {[
                { to: "/about", label: "About" },
                { to: "/services", label: "Services" },
                { to: "/contact", label: "Contact & Feedback" },
                { to: "/admin/login", label: "Admin" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-muted-foreground transition-colors duration-300 hover:text-primary">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-gold">Get in touch</p>
            <ul className="mt-5 space-y-4 text-sm">
              <li className="flex gap-3 text-muted-foreground">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" strokeWidth={1.5} />
                4/25, First Floor, G.T. Road, Shri Ram Nagar, Near UCO Bank, Shahdara, Delhi — 110032
              </li>
              <li>
                <a href="tel:+919015893925" className="flex gap-3 text-muted-foreground transition-colors duration-300 hover:text-primary">
                  <Phone className="h-4 w-4 shrink-0 text-primary" strokeWidth={1.5} /> +91 90158 93925
                </a>
              </li>
              <li>
                <a href="mailto:info@hypothoresearch.com" className="flex gap-3 text-muted-foreground transition-colors duration-300 hover:text-primary">
                  <Mail className="h-4 w-4 shrink-0 text-primary" strokeWidth={1.5} /> info@hypothoresearch.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-border pt-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} Hypotho Research. All rights reserved.</span>
          <span>Radiolabeling · Gamma Scintigraphy · Formulation · Clinical Trials</span>
        </div>
      </div>
    </footer>
  );
}
